import Logger from "../lib/logger";
import Lottie from "lottie-web";

const bunnyAnimationJson = require('../lottie/footer-bunny.json');

class ThemeFooter {
	NAME = 'ThemeFooter';

	/**
	 * Class static initialization block
	 */
	init() {
		Logger.info(`${this.NAME} > init`);

		this.footer_section = {
			bunny_animation: document.querySelector(`[data-theme-footer-bunny-animation]`),
			footer: document.querySelector("[data-theme-footer]"),
			footerPlaceholder: document.querySelector(`[data-theme-footer-placeholder]`),
			inner: document.querySelectorAll(".theme-footer__block-inner"),
			pluses_minuses: document.querySelectorAll(".theme-footer__block-btn-icon"),
			support_pane: document.querySelector(`[data-theme-footer-support-pane]`),
			support_pane_toggles: document.querySelectorAll(`[data-theme-footer-support-pane-toggle]`),
			footer_form: document.querySelector(`.theme-footer__newsletter-input`),
		};

		if (!this.footer_section.footer) return;

		this.mobile_nav = {
			nav: document.getElementById("theme-mobile_nav"),
			setWindowInnerHeightVar: () => {
				// interior height of the window in pixels
				document.documentElement.style.setProperty(
					"--window-inner-height",
					`${window.innerHeight}px`
				);

				const footerHeight = this.footer_section.footer.offsetHeight;
				this.footer_section.footerPlaceholder.style.height = `${footerHeight}px`;
			}
		};

		this.addHandlers();
		this.initBunnyAnimation();
		this.initFooterForm();
	}

	/**
	 * addHandlers --- Add event handlers for view
	 */
	addHandlers() {
		Logger.info(`${this.NAME} > addHandlers`);
		window.addEventListener("resize", this.mobile_nav.setWindowInnerHeightVar);
		this.mobile_nav.setWindowInnerHeightVar();
		this.footer_section.footer.addEventListener("click", this.onFooter.bind(this), true);

		// Support pane
		this.footer_section.support_pane_toggles.forEach(toggle => {
			toggle.addEventListener(`click`, e => {
				e.preventDefault();
				this.footer_section.support_pane.classList.toggle(`theme-footer-support-pane--active`);
			});
		});
	}

	/**
	 * initBunnyAnimation - Initialize the bunny animation
	 */
	initBunnyAnimation() {
		Logger.info(`${this.NAME} > initBunnyAnimation`);

		const svg = this.footer_section.bunny_animation.querySelector(`svg`);
		svg?.remove();

		const bunnyAnimation = Lottie.loadAnimation({
			container: this.footer_section.bunny_animation, // the dom element that will contain the animation
			renderer: 'svg',
			loop: true,
			autoplay: true,
			animationData: bunnyAnimationJson
		});
	}

	/**
	 * initFooterForm - Initialize the subscribe form in the footer
	 */
	initFooterForm() {
		Logger.info(`${this.NAME} > initFooterForm`);

		window.KlaviyoSubscribe.attachToForms(this.footer_section.footer_form, {
			hide_form_on_success: true,
			extra_properties: {
				$source: '$embed',
				$method_type: "Klaviyo Form",
				$method_id: 'embed',
				$consent_version: 'Embed default text'
			},
			success: function ($form) {
				setTimeout(function(){
					$('.nl-popup').css({'opacity': '0', 'pointer-events': 'none' });
				}, 3000);
				console.log($form);
				window.location.href = '/pages/thankyou';
			},
			error: function(error) {
				console.log(error);
			}
		});
	}

	/**
	 * onFooter
	 * @param {*} evt
	 */
	onFooter(evt) {
		const target = evt.target;

		if (target && target.nodeName === "BUTTON") {
			let classes = target.className.split(" ");
			if (classes) {
				// Search for class and react on match
				for (let x = 0; x < classes.length; x++) {
					switch (classes[x]) {
						/**
						 * Open clam-shell menu (and close open menus)
						 */
						case "theme-footer__block-btn":
							const siblings = this.getSiblings(target);

							// Close all clam-shells
							this.footer_section.inner.forEach((element) => {
								if (element.nodeName === "DIV")
									element.removeAttribute("aria-expanded");
							});

							// Open all plus_minuses
							this.footer_section.pluses_minuses.forEach((element) => {
								if (element.nodeName === "DIV")
									element.setAttribute("aria-expanded", "true");
							});

							siblings.forEach((element) => {
								if (element.nodeName === "DIV") {
									element.setAttribute("aria-expanded", "true");
									target.children[1].setAttribute("aria-expanded", "false"); // pluses_minuses icon toggle to minus sign of selected button

									// Below will scroll the page so that the button in question is aligned to the top of the page
									// but it will not work correctly in this setting
									// location.href = window.location.href + `#${target.id}`;
								}
							});
							break;
						default:
							break;
					}
				}
			}
		}
	}

	/**
	 * getSiblings --- Get element’s siblings
	 * @param elem
	 * @returns {*[]}
	 */
	getSiblings(elem) {
		// Setup siblings array the get the first sibling
		let siblings = [];
		let sibling = elem.parentNode.firstChild;
		// Loop through each sibling and push into the array
		while (sibling) {
			if (sibling.nodeType === 1 && sibling !== elem) {
				siblings.push(sibling);
			}
			sibling = sibling.nextSibling;
		}
		return siblings;
	};
}

export default ThemeFooter;
